import datapoints from '../datapoints';
import {
    ComposeOperation,
    getDefaultBodyType,
    lazyOpenCompose,
    lazyTrySaveAndCloseCompose,
    ComposeTarget,
    ComposeViewStateInitProps,
} from 'owa-mail-compose-store';
import { onNewMessage } from 'owa-mail-module-orchestrator';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
import { ActionSource } from 'owa-mail-store';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { getGuid } from 'owa-guid';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
// Load options now to retrieve emoji skin tone options before expression pane is opened
import 'owa-outlook-service-options';
import { isDeepLink } from 'owa-url';

export default createLegacyActionWithDatapoint('newMessage', datapoints.MailComposeNew)(
    async function newMessage(
        actionSource: ActionSource,
        targetId?: string, //target maybe group or public folder
        toEmailAddressWrappers?: EmailAddressWrapper[],
        subject?: string,
        body?: string,
        isPopout?: boolean
    ) {
        const openTarget = isPopout
            ? ComposeTarget.Popout
            : isTabViewEnabled() && !isDeepLink()
            ? ComposeTarget.SecondaryTab
            : ComposeTarget.PrimaryReadingPane;
        if (openTarget === ComposeTarget.PrimaryReadingPane) {
            await lazyTrySaveAndCloseCompose.importAndExecute(null /*viewState*/);
        }

        const bodyType = getDefaultBodyType();
        const toRecipients = [];

        if (toEmailAddressWrappers) {
            toRecipients.push(...toEmailAddressWrappers);
        }

        const logTraceId = getGuid();
        const newMessageDatapoint = returnTopExecutingActionDatapoint();
        // Datapoint is not present for unit tests
        if (newMessageDatapoint) {
            newMessageDatapoint.addCustomData({
                composeTraceId: logTraceId,
                actionSource: actionSource,
            });
        }

        const composeInitProps: ComposeViewStateInitProps = {
            operation: ComposeOperation.New,
            bodyType: bodyType,
            to: toRecipients,
            preferAsyncSend: true,
            subject: subject,
            newContent: body,
            logTraceId: logTraceId,
        };

        await lazyOpenCompose.importAndExecute(composeInitProps, openTarget, targetId);
        onNewMessage(openTarget === ComposeTarget.SecondaryTab);
    }
);
